var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-list"},[_c('Page',{attrs:{"total":_vm.total,"current":_vm.index,"show-elevator":_vm.showElevator,"show-total":"","show-sizer":_vm.showSizer,"page-size":_vm.size},on:{"on-change":_vm.pageChange,"on-page-size-change":_vm.pageSizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }